export enum CompleteOrderResultErrorCodeEnum {
    UnknownError = -1,
    NoError = 0,
    OrderDoesNotExist = 1,
    WavesClientIDZero = 2,
    ZoozRetrievePaymentError = 3,
    WebhookBreakPoint = 4,
    ITDevInsertZoozOrderError = 5,
    CreateVoidError = 6,
    CreateCaptureError = 7,
    InsertSubscriptionOrderError = 8,
}